import React, { useContext } from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import IconLink from '~/components/IconLink';
import Star from '~/components/Star';
import renderLink from '~/utils/render-link';
import TransContext from '~/contexts/TransContext';
import snap from '~/images/snap.png';
import snapFirstFrame from '~/images/snap-first-frame.png';
import { useInView } from 'react-intersection-observer';

export default function FooterCTA(props) {
  const trans = useContext(TransContext);

  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 1
  });

  const buttons = [
    props?.buttons?.length > 0 ? props?.buttons[0] : trans?.content?.footerCTAButtons[0],
    props?.buttons?.length > 1 ? props?.buttons[1] : trans?.content?.footerCTAButtons[1]
  ];

  return (
    <section className="relative my-12 lg:mt-28 bg-blue">
      <div className="container">
        <div className="relative z-10 flex justify-center py-20 md:py-28 lg:py-28 xl:py-48">
          <div className="absolute inset-0 flex-col items-center justify-center hidden lg:flex ">
            <div className="relative w-full h-full">
              <div className="absolute bottom-[15%] left-[20%]">
                <StaticImage placeholder="tracedSVG" width={60} src="../assets/icons/star-gradient.png" alt="" />
              </div>
              <div className="absolute top-[10%] right-[17%]">
                <StaticImage
                  className="transform rotate-[20deg]"
                  placeholder="tracedSVG"
                  width={50}
                  src="../assets/icons/star-gradient.png"
                  alt=""
                />
              </div>
              <div className="absolute top-[7%] left-[30%]">
                <Star className="transform rotate-45" />
              </div>
              <div className="absolute bottom-[15%] right-[10%]">
                <Star />
              </div>
            </div>
          </div>

          <div className="relative flex flex-col items-center">
            <div
              className="max-w-sm text-center text-white lg:max-w-3xl font-heading text-h1 "
              dangerouslySetInnerHTML={{ __html: props?.heading || trans?.content?.footerCTAHeading }}
            />

            {props.content && (
              <div
                className="max-w-sm mt-3 text-center text-white lg:max-w-xl text-20px"
                dangerouslySetInnerHTML={{ __html: props.content }}
              />
            )}

            <div className="flex flex-col lg:flex-row items-center lg:space-x-12 mt-8">
              {buttons[0] && (
                <div className="">
                  <Link to={renderLink(buttons[0].button?.cached_url)} className={`c-btn c-btn--black c-btn--long`}>
                    {buttons[0].title}
                  </Link>
                </div>
              )}

              {buttons[1] && (
                <div className="mt-4 lg:mt-0">
                  <IconLink to={renderLink(buttons[1].button?.cached_url)} color="white">
                    {buttons[1].title}
                  </IconLink>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="inset-0 flex-col items-start justify-end hidden md:flex md:absolute pt-28" ref={ref}>
          <div className="flex -ml-5" >
            <img src={inView ? snap : snapFirstFrame } className="h-full object-contain w-96" alt=""  />
          </div>
        </div>
      </div>
    </section>
  );
}
